module.exports = __webpack_public_path__ + "img/icon-skema.e6f33264.png";